import React from 'react'
import FbGetMenuHome from '../../Middleware/Firebase/FbGetMenuHome'
import '../../Css/barraMenu.css'

export default function BarraMenu() {


  return (
    <div className='div-barra'>
      <FbGetMenuHome/>
    </div>
  )
}